<!--
 * @Author: cryi.liu
 * @Date: 2020-05-14 14:27:11
 * @LastEditTime: 2020-06-13 09:28:59
 * @Description: 待编辑题库题目列表分页
 -->
<template>
   <i-page
    :total="total"
    :page-size="page.size"
    size="small"
    show-elevator show-total @on-change="pageIndexChanged" />
</template>

<script>
export default {
  name: 'WaitEditQuestionPage',
  props: {
    total: { type: Number, required: true },
    page: { type: Object, required: true },
  },
  methods: {
    /**
     * 分页索引发生改变
     */
    pageIndexChanged(index) {
      this.$emit('index-change', index);
    },
  },
};
</script>
